import {
  AdCreativeEventInit,
  AdCreativeFilter,
  AdCreativeUpdate,
  AdCreativeWithUrls,
  ListResult,
  SearchableFilter,
} from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'
import { AdCreative, AdCreativeInit } from 'common/api/v1/types'
import {
  AdCreativesRequestParams,
  PaginatedRequestParams,
  singleSortQueryFromPaginatedRequestParams,
} from '../nm-types'

export interface IAdCreativesApi {
  listAdCreatives(params?: PaginatedRequestParams): Promise<ListResult<AdCreativeWithUrls>>
  getAdCreative(id: AdCreative['id']): Promise<AdCreativeWithUrls>
  createAdCreative(adCreative: AdCreativeInit): Promise<AdCreativeWithUrls>
  updateAdCreative(id: AdCreative['id'], adCreative: AdCreative): Promise<AdCreativeWithUrls>
  deleteAdCreative(id: AdCreative['id']): Promise<AdCreative>
}

export class AdCreativesApi implements IAdCreativesApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  async listAdCreatives(params: AdCreativesRequestParams): Promise<ListResult<AdCreativeWithUrls>> {
    const filter = {
      searchName: params.filter,
      fromDate: params.fromDate ? new Date(params.fromDate) : undefined,
      toDate: params.toDate ? new Date(params.toDate) : undefined,
      status: params.status,
    } as AdCreativeFilter

    const query = singleSortQueryFromPaginatedRequestParams<SearchableFilter, string>({
      filter,
      paginatedRequestParams: params,
    })
    return this.edgeClient.listAdCreatives(query)
  }

  getAdCreative(id: string): Promise<AdCreativeWithUrls> {
    return this.edgeClient.getAdCreative(id)
  }

  createAdCreative(adCreative: AdCreativeInit): Promise<AdCreativeWithUrls> {
    return this.edgeClient.createAdCreative(adCreative)
  }

  updateAdCreative(id: string, adCreative: AdCreativeUpdate): Promise<AdCreativeWithUrls> {
    return this.edgeClient.updateAdCreative(id, adCreative)
  }

  deleteAdCreative(id: string): Promise<AdCreative> {
    return this.edgeClient.deleteAdCreative(id)
  }

  createAdCreativeEvent(id: string, adCreativeEvent: AdCreativeEventInit): Promise<Pick<AdCreativeEventInit, 'type'>> {
    return this.edgeClient.setAdCreativeEvent(id, adCreativeEvent)
  }
}
